import Vue from "vue";
import VueToast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import store from "@/store";
import router from "@/router";
import routes from "@/router/routes";

Vue.use(VueToast);

const interceptorResponse = (response) => {
  store.dispatch("cleanErrorResponse");
  return response;
};

const interceptorError = (error, pathRoute) => {
  let { status, message } = error.response;
  if (status !== 400 && status !== 401) {
    //this.$toast("I'm a toast!");
    switch (status) {
      case 403:
        message =
          "Acesso não autorizado! Verifique a sua VPN ou fale com um responsável técnico.";
        break;
      case 500:
        message =
          "Sem conexão! Verifique o seu acesso à internet ou fale com um responsável técnico.";
        break;
    }

    if (pathRoute) {
      router.push({ name: "ResponseError", params: { message, status } });
    } else if (message) {

      throw error
/*       Vue.$toast.open({
        message,
        type: "error",
        duration: 5000,
        dismissible: true,
      }); */
      //store.dispatch('setErrorResponse', {message: message});
    }
  }

  if (status === 401 && store.getters.loggedIn) {
    store.dispatch("logOut");
    router.push({ path: routes.login.path });
    Vue.$toast.open({
      message: "Sessão expirada! Efetue o login novamente.",
      type: "error",
      duration: 5000,
      dismissible: true,
    });
  }

  if (status === 401 && store.getters.loggedIn) {
    store.dispatch("logOut");
    router.push({ path: routes.login.path });
    Vue.$toast.open({
      message: "Sessão expirada! Efetue o login novamente.",
      type: "error",
      duration: 5000,
      dismissible: true,
    });
  }

  const node_env = `${process.env.NODE_ENV}`;
  if (node_env === "production") {
    console.clear();
  }

  return Promise.reject(error);
};

export { interceptorResponse, interceptorError };
